import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import MixAndMatchListTable from "./mix-and-match-list-table";
import Paginat from "@/components/lib/paginat";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useFilter } from "@/hooks/useFilter";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";

function MixAndMatchDraftListTabs() {
  const { mixAndMatches } = useSelector((state) => state.menuManage.mixAndMatch);

  const [perPage, setPerPage] = useState(10);
  const [filters] = useState({
    status: "draft",
  });
  const [searchText, setSearchText] = useState("");

  const filteredData = useFilter(mixAndMatches, filters, 300);
  const searchData = useSearch(
    filteredData,
    searchText,
    ["id", "name"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="draft">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-4 items-start lg:items-center">
          <div className="w-full sm:w-[280px]">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2.5 left-3"
              />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search Drafts..."
                className="bg-cblack3 pl-9 border-cblack6"
              />
            </div>
          </div>
          <div className="flex gap-2 items-center text-sm text-cwhite2">
            <span>Show</span>
            <Select
              onValueChange={(value) => setPerPage(Number(value))}
              value={perPage.toString()}
            >
              <SelectTrigger className="w-[70px] bg-cblack3 border-cblack6">
                <SelectValue placeholder="10" />
              </SelectTrigger>
              <SelectContent className="bg-cblack3 border-cblack6 text-cwhite">
                <SelectGroup>
                  <SelectItem value="10">10</SelectItem>
                  <SelectItem value="20">20</SelectItem>
                  <SelectItem value="50">50</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="mt-4">
          <MixAndMatchListTable mixAndMatches={paginatedData} />
        </div>

        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default MixAndMatchDraftListTabs;
